var map = {
	"./chartmuseum.png": "b162",
	"./docker-registry.png": "9792",
	"./elasticsearch.png": "bd4d",
	"./grafana.png": "5750",
	"./kubeapps.png": "affb",
	"./kubernetes.png": "f321",
	"./loki.png": "9614",
	"./prometheus.png": "df95",
	"./registry.png": "2ee9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e068";